import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { ConsumerTransactionActions } from "../../actions/consumer-log.actions";
import { AchStatusState } from "../../models/consumer-logs/ach-status-state";

const initialState: AchStatusState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(ConsumerTransactionActions.achStatus.getApi, (state) => ({ ...state, loading: true })),
	on(ConsumerTransactionActions.achStatus.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		..._.omit(action, "type")
	})),
	on(ConsumerTransactionActions.achStatus.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function achStatusReducer(state: AchStatusState | undefined, action: Action) {
	return reducer(state, action);
}
